// extracted by mini-css-extract-plugin
export default {"container":"UserCommentsBlock_container__696gQ"};